import { createFilterPanelService } from '@gmini/common/lib/components'

export const filterPanelService = createFilterPanelService()
